import {Component, Input, OnInit} from '@angular/core';
import {BundesLandName} from '../../../../../../../model/component/bundesland';
import {BundeslandFilterService} from '../../../../../../../service/bundeslandFilter/bundesland-filter.service';
import {MatTabChangeEvent} from '@angular/material/tabs';

@Component({
  selector: 'app-wintersport-wetter',
  templateUrl: './wintersport-wetter.component.html',
  styleUrls: ['./wintersport-wetter.component.css']
})
export class WintersportWetterComponent implements OnInit {

  selectedBundesland: string;
  selectedIndex = 0;


  constructor(public bundeslandFilterService: BundeslandFilterService) {
    this.selectedBundesland = this.bundeslandFilterService.selectedBundesLand.name;
  }

  ngOnInit(): void {
  }


  isAvailableForBundesland() {
    return this.selectedBundesland === BundesLandName.BE || this.selectedBundesland === BundesLandName.BB;
  }
  onTabChange($event: MatTabChangeEvent) {
    this.selectedBundesland = $event.tab.textLabel;
    this.selectedIndex = 0;
  }
}
